import axios from "@/axios/index";
export function getUserInfo(token){
    return axios.post("/api/client/getUserInfo",{},{
        headers:{
            token:token
        }
    })
}
export function getGameClassList(){
    return axios.post("/api/gameCls/getListWithOptions",{})
}
export function getGameList(optionIdArr,page){
    return axios.post("/api/game/getList",{
        optionIdArr:optionIdArr,
        page:page
    })
}
export function getGameListByKeyWord(keyword,page){
    return axios.post("/api/game/getList",{
        keyword:keyword,
        page:page
    })
}
export function getGameDetail(id){
    return axios.post("/api/game/detail",{
        id:id
    },{
        headers:{
            token:localStorage.getItem("token")
        }
    })
}
export function createOrder(vipType){
    return axios.post("/api/pay/createOrder",{id:vipType},{
       headers:{
           token:localStorage.getItem("token")
       }
    })
}
export function getVipList(){
    return axios.post("/api/vip/getList",{},{
        headers:{
            token:localStorage.getItem("token")
        }
    })
}
export function getGameCount(){
    return axios.post("/api/game/getGameCount",{},{
        headers:{
            token:localStorage.getItem("token")
        }
    })
}
export function bindAdmin(adminId){
    return axios.post("/api/client/bindAdmin",{
        adminId:adminId
    },{
        headers:{
            token:localStorage.getItem("token")
        }
    })
}